export default {
  "All types": "Tous les types",
  Customers: "Clients",
  customers: "clients",
  "Add a customer": "Ajouter un client",
  Active: "Actif",
  Inactive: "Inactif",
  Pending: "En attente",
  Name: "Nom",
  Phone: "Téléphone",
  City: "Ville",
  Status: "Statut",
  "Created At": "Créé le",
  Actions: "Actions",

  "Full Name": "Nom complet",
  "First Name": "Prénom",
  "Last Name": "Nom de famille",
  Address: "Adresse",
  Region: "Région",
  Country: "Pays",
  "Date of Birth": "Date de naissance",

  Customer: "Client",
  "Search customer by name, phone, or city":
    "Rechercher un client par nom, téléphone ou ville",
  "Edit Selection": "Modifier la sélection",
  "No customers found": "Aucun client trouvé",

  "Create a new customer": "Créer un nouveau client",

  "Edit Customer": "Modifier le client",

  "General Information": "Informations générales",
  Relationships: "Relations",
  Metadata: "Métadonnées",
  Segment: "Segment",
  Business: "Entreprise",
  Shop: "Boutique",
  Orders: "Commandes",
  "Segment ID": "ID du segment",
  "Business ID": "ID de l'entreprise",
  "Shop ID": "ID de la boutique",
  "Updated At": "Mis à jour le",

  "All segments": "Tous les segments",
  "All status": "Tous les statuts",

  "Add customer": "Ajouter un client",

  Particular: "Particulier",
  Enterprise: "Entreprise",
  Debt: "Dette",
  "Do you really want to delete this Customer?":
    "Voulez-vous vraiment supprimer ce client ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Attention : cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",
  "All customers": "Tous les clients",
  "Owing customers": "Clients avec dettes",
  "Not Owing customers": "Clients sans dettes",

  "Walk in customer": "Client de passage",
};
